import React, { useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import { PageHero, FeatureGrid, CTABand } from "@/components/public/PageHero";
import { HeartHandshake, Compass, ShieldCheck, Users, Home, Clock } from "lucide-react";

const FEATURES = [
  { icon: Compass, title: "One clear plan", body: "We help you see all your options and choose the next right step — without rushing." },
  { icon: HeartHandshake, title: "One caring guide", body: "The same person walks with your family from the first call through the whole journey." },
  { icon: ShieldCheck, title: "Trusted professionals", body: "Vetted local movers, realtors, and contractors — coordinated so you don't have to." },
  { icon: Home, title: "Whatever your loved one needs", body: "Stay home safely, move in with you, find senior living, or sell the family home." },
  { icon: Users, title: "The whole family", body: "We help siblings and caregivers get on the same page, gently and honestly." },
  { icon: Clock, title: "At your pace", body: "No pressure. We slow things down so decisions feel calm and confident." },
];

export default function ForFamilies() {
  const { content } = useOutletContext();
  useEffect(() => { document.title = "For Families · MovingMyMama"; }, []);
  const img = content?.trust?.image_url || content?.hero?.image_url;
  return (
    <div data-testid="for-families-page">
      <PageHero
        eyebrow="For Families"
        title="You don't have to figure this out alone."
        subtitle="When it's time to make the next move for your loved one, we're the calm, caring guide by your side — every step of the way."
        image={img}
      />
      <FeatureGrid items={FEATURES} />
      <CTABand
        title="Ready to talk it through?"
        subtitle="Start with a free 1-hour consultation. We'll help you find a clear, calm path forward."
      />
    </div>
  );
}
